import { OnboardingWorkflow } from '../../../interfaces/onboarding.interface';

/**
 * Eén stap van een rondleiding (docs/ONBOARDING.md, "Rondleiding: A").
 *
 * - `route`: eerst hierheen; daarna wacht de rondleiding (tot ~5 s) tot het
 *   doel er is. Zonder route blijft hij op de pagina waar je bent.
 * - `doel`: CSS-selector, altijd een `[data-rondleiding="…"]` op het echte
 *   element, zodat een andere klassenaam de rondleiding niet breekt.
 * - `titel`, `tekst`: i18n-sleutels.
 *
 * Staat het doel niet op het scherm (bijv. op de telefoon, of omdat het pas
 * verschijnt na een keuze), dan staat de ballon midden onderin zonder
 * spotlight.
 */
export interface IRondleidingStap {
  route?: string;
  doel: string;
  titel: string;
  tekst: string;
}

const doel = (naam: string) => `[data-rondleiding="${naam}"]`;
const t = (workflow: string, stap: string) => ({
  titel: `ONBOARDING.tour.${workflow}.${stap}.titel`,
  tekst: `ONBOARDING.tour.${workflow}.${stap}.tekst`,
});

export const RONDLEIDINGEN: Record<OnboardingWorkflow, IRondleidingStap[]> = {
  // Over de echte uploadflow: menu -> bestand of link -> wedstrijd -> opslaan.
  upload: [
    { doel: doel('upload-menu'), ...t('upload', 'menu') },
    { route: '/upload', doel: doel('upload-bron'), ...t('upload', 'bron') },
    // Verschijnen pas na het kiezen van een bestand of link; tot dan staat
    // de ballon midden onderin en zegt de tekst wat je eerst doet.
    { doel: doel('upload-wedstrijd'), ...t('upload', 'wedstrijd') },
    { doel: doel('upload-opslaan'), ...t('upload', 'opslaan') },
  ],
  // TODO(onboarding): plannen, taggen en playlists krijgen hun volledige
  // stappen in een vervolg-PR. Nu alleen de eerste stap (de ingang in het
  // menu), zodat "Show me" nooit niets doet.
  plannen: [
    { doel: doel('plannen-menu'), ...t('plannen', 'menu') },
  ],
  taggen: [
    { doel: doel('taggen-menu'), ...t('taggen', 'menu') },
  ],
  playlists: [
    { doel: doel('playlists-menu'), ...t('playlists', 'menu') },
  ],
};
